/*
    自定义常量
*/

/**
 * 专利申请号链接地址
 */
const patentAppNoBaseUrl = 'https://data.epo.org/linked-data/doc/application'

/**
 * 专利公布号链接地址
 */
const publicationNumberBaseUrl = 'https://data.epo.org/linked-data/data/publication'

/**
 * 专利公布号在列表中的链接地址
 */
const publicationNumberBaseUrlInList = 'https://worldwide.espacenet.com/searchResults'

/**
 * 根据类型获取数据子典枚举
 * @param type
 * @param listCur
 * @param callback
 */
function getEnumsDictionariesList(type, listCur, callback) {
  listCur.splice(0, listCur.length)
  baseEnumsSelectDictionariesType(type)
    .then(result => {
      if (result.code === 200) {
        const data = result.data
        // listCur = result.data

        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          item.text = item.value
          item.textEn = item.valueEn
          item.label = item.value
          item.labelEn = item.valueEn
          // item.value = item.key
          listCur.push(item)
        }
      } else {
        // this.$message({
        //   type: "error",
        //   message: result.message
        // });
      }
      if (
        callback instanceof Function
      ) {
        callback()
      }
    })
    .catch(() => {
      if (
        callback instanceof Function
      ) {
        callback()
      }
    })
}

/**
 * 获取地区/国家枚举
 * @param higherNo 获取顶级传 0
 * @param listCur
 * @param callback
 */
function getEnumsSelectAreaNoList(type, listCur, callback) {
  listCur.splice(0, listCur.length)
  baseEnumsSelectAreaNo(type)
    .then(result => {
      if (result.code === 200) {
        const data = result.data
        // listCur = result.data

        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          item.text = item.name
          item.textEn = item.nameEn
          item.label = item.name
          item.labelEn = item.nameEn
          // item.value = item.areaNo
          item.key = item.areaNo
          listCur.push(item)
        }
      } else {
        // this.$message({
        //   type: "error",
        //   message: result.message
        // });
      }
      if (
        callback instanceof Function
      ) {
        callback()
      }
    })
    .catch(() => {
      if (
        callback instanceof Function
      ) {
        callback()
      }
    })
}

/**
 * 查询专利的的国家地区
 * @param listCur
 * @param callback
 */
function getEnumsSelectAreaPatentList(listCur, callback) {
  listCur.splice(0, listCur.length)
  baseEnumsSelectAreaPatent()
    .then(result => {
      if (result.code === 200) {
        const data = result.data
        // listCur = result.data

        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          item.text = item.name
          item.textEn = item.nameEn
          item.label = item.name
          item.labelEn = item.nameEn
          // item.value = item.code
          item.key = item.code
          listCur.push(item)
        }
      } else {
        // this.$message({
        //   type: "error",
        //   message: result.message
        // });
      }
      if (
        callback instanceof Function
      ) {
        callback()
      }
    })
    .catch(() => {
      if (
        callback instanceof Function
      ) {
        callback()
      }
    })
}

/**
 * 获取要返回的路由项
 * @param thisCom
 * @param fieldNameArray
 */
function getGoBackRouterItem(thisCom, fieldNameArray) {
  fieldNameArray =
    fieldNameArray === undefined ||
    fieldNameArray === null ||
    !(fieldNameArray instanceof Array)
      ? ['id']
      : fieldNameArray // 默认有id
  const query = thisCom.$route.query
  let goBackRouteName = query.goBackRouteName // 返回路由的名称
  // let fromid = query.fromid//返回页面的参数id
  // let fromcode = query.fromcode
  // let fromshopType = query.fromshopType
  if (
    goBackRouteName === undefined ||
    goBackRouteName === null ||
    goBackRouteName === ''
  ) {
    goBackRouteName = thisCom.goBackRouteName
  }
  const routerItem = { name: goBackRouteName, query: {}} // 路由项

  // 当goBackRouteName不止一个的时候，是用英文逗号“,”隔开的
  // 多个goBackRouteName，越靠前的代表是先返回的路由名称，靠后的是后返回的，以此类推
  const goBackRouteNameArray = goBackRouteName.split(',')
  if (goBackRouteNameArray.length > 1) {
    // 如果大于1个，则说明有多个
    routerItem.name = goBackRouteNameArray[0] // 第一个是当前要返回的路由名称
    goBackRouteNameArray.splice(0, 1) // 删除第一个
    const goBackRouteNamesNew = goBackRouteNameArray.join(',') // 重新转为字符串
    routerItem.query.goBackRouteName = goBackRouteNamesNew // 继续回传给上一个
  }

  // //fromid逻辑同goBackRouteName
  // if(fromid !== undefined && fromid !== null && fromid !== ''){
  //   let fromidArray = fromid.toString().split(',')
  //   if(fromidArray.length > 1){
  //     //如果大于1个，则说明有多个
  //     routerItem.query[idFieldName] = fromidArray[0]//第一个是当前的id
  //     fromidArray.splice(0,1)//删除第一个
  //     let fromidsNew = fromidArray.join(',')//重新转为字符串
  //     routerItem.query.fromid = fromidsNew//继续回传给上一个
  //   }
  // }
  const paramObj = getAboutParamObjToGoBack(thisCom, fieldNameArray) // 获取要返回页面的相关参数
  Object.assign(routerItem.query, paramObj) // 合并到路由参数中
  const fromFieldNameArray = []
  fieldNameArray.forEach(function(item) {
    fromFieldNameArray.push('from' + item)
  })

  // 添加其它参数
  const excludeQueryItemArray = [
    'goBackRouteName',
    ...fieldNameArray,
    ...fromFieldNameArray
  ]
  const otherQuery = getOtherParam(thisCom, excludeQueryItemArray) // 获取其它参数
  Object.assign(routerItem.query, otherQuery) // 合并到路由参数中
  // console.log(otherQuery)

  // //fromcode逻辑同goBackRouteName
  // if(fromcode !== undefined && fromcode !== null && fromcode !== ''){
  //   let fromcodeArray = fromcode.toString().split(',')
  //   if(fromcodeArray.length > 1){
  //     //如果大于1个，则说明有多个
  //     routerItem.query['code'] = fromcodeArray[0]//第一个是当前的id
  //     fromcodeArray.splice(0,1)//删除第一个
  //     let fromcodesNew = fromcodeArray.join(',')//重新转为字符串
  //     routerItem.query.fromcode = fromcodesNew//继续回传给上一个
  //   }
  //   else{
  //     routerItem.query['code'] = fromcode
  //   }
  // }

  // //fromcode逻辑同goBackRouteName
  // if(fromshopType !== undefined && fromshopType !== null && fromshopType !== ''){
  //   let fromcodeArray = fromshopType.toString().split(',')
  //   if(fromcodeArray.length > 1){
  //     //如果大于1个，则说明有多个
  //     routerItem.query['shopType'] = fromcodeArray[0]//第一个是当前的id
  //     fromcodeArray.splice(0,1)//删除第一个
  //     let fromcodesNew = fromcodeArray.join(',')//重新转为字符串
  //     routerItem.query.fromshopType = fromcodesNew//继续回传给上一个
  //   }
  //   else{
  //     routerItem.query['shopType'] = fromshopType
  //   }
  // }

  return routerItem
}

/**
 * 获取要返回页面的相关参数
 * @param thisCom
 * @param fieldNameArray
 */
function getAboutParamObjToGoBack(thisCom, fieldNameArray) {
  const paramObj = {}
  if (
    fieldNameArray === undefined ||
    fieldNameArray === null ||
    !(fieldNameArray instanceof Array)
  ) {
    return paramObj
  }

  const query = thisCom.$route.query
  for (let i = 0; i < fieldNameArray.length; i++) {
    const fieldName = fieldNameArray[i]
    const fromFieldName = 'from' + fieldName
    const fromFieldValue = query[fromFieldName]

    if (
      fromFieldValue !== undefined &&
      fromFieldValue !== null &&
      fromFieldValue !== ''
    ) {
      const valueArray = fromFieldValue.toString().split(',')
      if (valueArray.length > 1) {
        // 如果大于1个，则说明有多个
        paramObj[fieldName] = valueArray[0] // 第一个是当前的id
        valueArray.splice(0, 1) // 删除第一个
        const valuesNew = valueArray.join(',') // 重新转为字符串
        paramObj[fromFieldName] = valuesNew // 继续回传给上一个
      } else {
        paramObj[fieldName] = fromFieldValue // 如果只有一个，则作为当前字段的值
      }
    } else {
      paramObj[fromFieldName] = undefined // 没有这一项就清除项
    }
  }

  return paramObj
}

/**
 * 获取其它参数
 * @param thisCom
 * @param excludeQueryItemArray
 */
function getOtherParam(thisCom, excludeQueryItemArray) {
  excludeQueryItemArray =
    excludeQueryItemArray === undefined ||
    excludeQueryItemArray === null ||
    !(excludeQueryItemArray instanceof Array)
      ? []
      : excludeQueryItemArray
  const query = thisCom.$route.query
  let isBackWithOtherQuery = query.isBackWithOtherQuery // 是否回传其它参数
  isBackWithOtherQuery =
    isBackWithOtherQuery === undefined ||
    isBackWithOtherQuery === null ||
    isBackWithOtherQuery === ''
      ? 'false'
      : isBackWithOtherQuery
  const otherQuery = {}
  if (isBackWithOtherQuery.toString().toLowerCase() === 'true') {
    // 添加其它参数到现在参数中
    for (const itemName in query) {
      // if(itemName === 'goBackRouteName' || itemName === 'fromid' ){
      if (excludeQueryItemArray.indexOf(itemName) >= 0) {
        // || itemName === 'isBackWithOtherQuery'
        continue
      }
      const item = query[itemName]
      otherQuery[itemName] = item
    }
  }

  return otherQuery
}

/**
 * 获取要跳转到下个页面的返回路由的名称
 * @param thisCom
 */
function getGoBackRouteNameToOpenPage(thisCom) {
  const query = thisCom.$route.query
  const routeNameCur = thisCom.$route.name
  let goBackRouteName = query.goBackRouteName // 返回路由的名称
  if (
    goBackRouteName === undefined ||
    goBackRouteName === null ||
    goBackRouteName === ''
  ) {
    // 如果没有goBackRouteName参数，则下个页面的goBackRouteName就是当前的curRouteName
    goBackRouteName = routeNameCur // thisCom.curRouteName
  } else {
    // 如果存在goBackRouteName参数，则当前的curRouteName作为第一个goBackRouteName
    goBackRouteName = routeNameCur + ',' + goBackRouteName // thisCom.curRouteName + ',' + goBackRouteName
  }

  return goBackRouteName
}

/**
 * 获取要跳转到下个页面的参数fromid
 * @param thisCom
 * @param idFieldName
 */
function getFromIdToOpenPage(thisCom, idFieldName) {
  idFieldName =
    idFieldName === undefined || idFieldName === null || idFieldName === ''
      ? 'id'
      : idFieldName
  const query = thisCom.$route.query
  let fromid = query.fromid // 页面的参数fromid
  if (fromid === undefined || fromid === null || fromid === '') {
    // 如果没有fromid参数，则下个页面的fromid就是当前的id
    fromid = query[idFieldName]
  } else {
    // 如果存在fromid参数，则当前的id作为第一个fromid
    fromid = query[idFieldName] + ',' + fromid
  }

  return fromid
}

/**
 * 获取要跳转到下个页面的参数from开头的参数
 * @param thisCom
 * @param fieldName
 */
function getFromParamToOpenPage(thisCom, fieldName) {
  fieldName =
    fieldName === undefined || fieldName === null || fieldName === ''
      ? ''
      : fieldName
  const query = thisCom.$route.query
  let fromcode = query['from' + fieldName] // 页面的参数fromcode
  if (fromcode === undefined || fromcode === null || fromcode === '') {
    // 如果没有fromcode参数，则下个页面的fromcode就是当前的code
    fromcode = query[fieldName]
  } else {
    // 如果存在fromcode参数，则当前的code作为第一个fromcode
    fromcode = query[fieldName] + ',' + fromcode
  }

  return fromcode
}

/**
 * 获取要跳转到下个页面的from参数
 * @param thisCom
 * @param fieldNameArray
 */
function getFromParamObjToOpenPage(thisCom, fieldNameArray) {
  const fromParamObj = {}
  if (
    fieldNameArray === undefined ||
    fieldNameArray === null ||
    !(fieldNameArray instanceof Array)
  ) {
    return fromParamObj
  }

  // let fromFieldNameArray = []//from字段名集合
  for (let i = 0; i < fieldNameArray.length; i++) {
    const fieldName = fieldNameArray[i]
    const fromFieldName = 'from' + fieldName
    fromParamObj[fromFieldName] = getFromParamToOpenPage(thisCom, fieldName) // 获取要跳转到下个页面的参数from

    // fromFieldNameArray.push(fromFieldName)
  }

  return fromParamObj
}

/**
 * 根据字段名获取对应from字段数组
 * @param thisCom
 * @param fieldName
 */
function getFromFieldValueArrayByFieldName(thisCom, fieldName) {
  const query = thisCom.$route.query
  const fromFieldName = 'from' + fieldName
  const fromFieldValue = query[fromFieldName]
  let fromFieldValueArray = []
  if (
    fromFieldValue !== undefined &&
    fromFieldValue !== null &&
    fromFieldValue !== ''
  ) {
    fromFieldValueArray = fromFieldValue.toString().split(',')
  }

  return fromFieldValueArray
}

/**
 * 获取要跳转到下个页面的参数
 * @param thisCom
 * @param idFieldName
 */
function getQueryDataToOpenPage(thisCom, fieldNameArray) {
  fieldNameArray =
    fieldNameArray === undefined ||
    fieldNameArray === null ||
    !(fieldNameArray instanceof Array)
      ? ['id']
      : fieldNameArray // 默认有id
  const queryData = {}

  // 添加其它参数
  // let excludeQueryItemArray = ['goBackRouteName', ...fieldNameArray]
  const otherQuery = getOtherParam(thisCom) // 获取其它参数
  Object.assign(queryData, otherQuery) // 合并到路由参数中
  queryData.goBackRouteName = getGoBackRouteNameToOpenPage(thisCom) // 获取要跳转到下个页面的返回路由的名称
  // queryData.fromid = getFromIdToOpenPage(thisCom, idFieldName)//获取要跳转到下个页面的参数fromid
  // queryData.fromcode = getFromCodeToOpenPage(thisCom)//获取要跳转到下个页面的参数fromcode
  // queryData.fromshopType = getFromParamToOpenPage(thisCom,'shopType')//获取要跳转到下个页面的参数fromshopType
  // queryData.fromstatus = getFromParamToOpenPage(thisCom,'status')//获取要跳转到下个页面的参数fromstatus
  const fromParamObj = getFromParamObjToOpenPage(thisCom, fieldNameArray) // 获取要跳转到下个页面的from参数
  Object.assign(queryData, fromParamObj) // 合并到路由参数中

  return queryData
}

/**
 * 通用下拉列表指令事件
 * @param command
 */
function commonDropdownCommandHandler(command){
  if(!command || !command.action){
    return
  }
  let thisCom = command.thisCom
  // console.log(thisCom,this)
  // console.log(typeof command.action)
  if(thisCom){
    if(typeof command.action == "function"){
      // command.action(...command.param)
      command.action.call(command.thisCom, ...command.param)
    }
    else if(typeof command.action == "string"){
      // this[command.action](...command.param)
      command.thisCom[command.action].call(command.thisCom, ...command.param)
    }
  }
  else{
    if(typeof command.action == "function"){
      command.action(...command.param)
    }
    else if(typeof command.action == "string" && this){
      this[command.action](...command.param)
    }
  }
}

import { baseEnumsSelectDictionariesType, baseEnumsSelectAreaNo, baseEnumsSelectAreaPatent } from '@/api/enumInfo.js'

export default {
  patentAppNoBaseUrl,
  publicationNumberBaseUrl,
  publicationNumberBaseUrlInList,
  getEnumsDictionariesList,
  getEnumsSelectAreaNoList,
  getEnumsSelectAreaPatentList,
  getGoBackRouterItem,
  getOtherParam,
  getGoBackRouteNameToOpenPage,
  getFromIdToOpenPage,
  getQueryDataToOpenPage,
  getFromFieldValueArrayByFieldName,
  commonDropdownCommandHandler
}
